var path = '/pages/guestlists/components/rsvp-guests-full/component.tpl.html';
var html = "<listview store=\"vm.store\" ng-if=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/components/rsvp-guests-full/component.tpl.html
// module id = 2254
// module chunks = 1